import { Typography, Box } from '@mui/material';
import { FC } from 'react';

import { ReactComponent as SuccessIconVS } from 'src/assets/svg/success-green-circle.svg';
import { ReactComponent as SuccessIconHos } from 'src/assets/svg/success-in-hos.svg';
import { ReactComponent as ExclamationIconVS } from 'src/assets/svg/subtract.svg';
import { ReactComponent as ExclamationIconHos } from 'src/assets/svg/warning-hos.svg';
import { ReactComponent as ArrowRight } from 'src/assets/svg/arrow-right.svg';
import { getTheme } from 'src/utils/getTheme';

import { styles } from './styles';

import type { AcknowledgeSummaryBoxProps } from './types';

export const AcknowledgeSummaryBox: FC<AcknowledgeSummaryBoxProps> = ({
    signed,
    content,
    showAgreementDrawer,
}) => {
    const { isHosTheme } = getTheme();

    let Icon;
    if (isHosTheme) {
        Icon = signed ? SuccessIconHos : ExclamationIconHos;
    } else {
        Icon = signed ? SuccessIconVS : ExclamationIconVS;
    }

    return (
        <Box css={styles.container(signed)} onClick={showAgreementDrawer}>
            <Box css={styles.wrapper}>
                <Icon />
                <Typography variant="h3" css={styles.text}>
                    {content}
                </Typography>
                <Box css={styles.arrow}>
                    <ArrowRight />
                </Box>
            </Box>
        </Box>
    );
};
